import React from "react";
// import { FormFeedback } from "reactstrap";
import Info from "../../files/Courses_en.json";

const Courses_In = () => {
  return (
    <div>
      {Info.map(function (item, i) {
        if (item.ident === "H") {
          return (
            <div key={i} className="row">
              <div className="col-lg-12 text-left">
                <p
                  dangerouslySetInnerHTML={{
                    __html: item.text,
                  }}
                ></p>
              </div>
            </div>
          );
        } else {
          return null;
        }
      })}
      {Info.map(function (item, i) {
        if (item.ident === "B") {
          return (
            <div key={i} className="row">
              <div className="col-lg-12 text-left">
                <h5 key={i}>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: item.title,
                    }}
                  ></span>
                  <span> - </span>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: item.text,
                    }}
                  ></span>
                </h5>
              </div>
            </div>
          );
        } else {
          return null;
        }
      })}
      <br />
      {Info.map(function (item, i) {
        if (item.ident === "F") {
          return (
            <div key={i} className="row">
              <div className="col-lg-12 text-left">
                <p
                  dangerouslySetInnerHTML={{
                    __html: item.text,
                  }}
                ></p>
 
              </div>
            </div>
          );
        } else {
          return null;
        }
      })}
      <br />
    </div>
  );
};

export default Courses_In;
